import { render } from "./ChromeExtension.vue?vue&type=template&id=5d874c7a"
import script from "./ChromeExtension.vue?vue&type=script&lang=js"
export * from "./ChromeExtension.vue?vue&type=script&lang=js"

import exportComponent from "/Users/georgwidschwendter/Documents/GitHub/learn/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__